import { render, staticRenderFns } from "./files-with-preview.vue?vue&type=template&id=6330e991&scoped=true&"
import script from "./files-with-preview.vue?vue&type=script&lang=js&"
export * from "./files-with-preview.vue?vue&type=script&lang=js&"
import style0 from "./files-with-preview.vue?vue&type=style&index=0&id=6330e991&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6330e991",
  null
  
)

export default component.exports